import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { MarkupAction } from '@cbridge-packages/markup';
import { InfinityDataGridAction } from '@cbridge-modules/infinity-data-grid';

export const reloadMarkupListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    MarkupAction.update.done,
    MarkupAction.bulkUpdate.done,
    MarkupAction.bulkRemove.done,
  ),
  map(() => InfinityDataGridAction.refreshData()),
);
